import api from './index';

let exports = {};

//合同列表
exports.getContractList = function (params, callback) {// 获取带分页的合同列表
    api.post('/contract/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getContractGoodsListByContractId = function (params, callback) {// 根据合同id获取合同商品列表, 不带分页
    api.post('/contract/goods/list/get/by/contractId')
    .data(params)
    .done(callback)
    .go();
};

//登记合同信息
exports.registContract = function (params, callback) {// 登记合同信息
    api.post('/contract/regist/do')
    .data(params)
    .done(callback)
    .go();
};

//查询合同信息
exports.getContractInfo = function (params, callback) {// 查询合同信息
    api.post('/contract/info/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getContractGoodsPagedListByContractId = function (params, callback) {// 根据合同id获取合同商品分页列表
    api.post('/contract/goods/paged/list/get/by/contractId')
    .data(params)
    .done(callback)
    .go();
};

//删除商品合同信息
exports.deleteContract = function (params, callback) {// 删除商品合同信息
    api.post('/contract/delete/do')
    .data(params)
    .done(callback)
    .go();
};

//作废合同
exports.doInvalidContract = function (data, callback) {
    api.post('/contract/invalid/do')
    .data(data)
    .done(callback)
    .go();
};

//更新合同信息
exports.updateContract = function (params, callback) {// 更新合同信息
    api.post('/contract/update/do')
    .data(params)
    .done(callback)
    .go();
};

//更新合同所有信息
exports.updateContractInfo = function (data, callback) {
    api.post('/contract/info/update/do')
    .data(data)
    .done(callback)
    .go();
};

//确认合同信息
exports.auditAndConfirmContract = function (params, callback) {// 确认合同信息
    api.post('/contract/audit/and/confirm/do')
    .data(params)
    .done(callback)
    .go();
};

//确认合同信息
exports.getContractServcByContractIdAndSsuId = function (params, callback) {// 判断合同中是否存在服务
    api.post('/contract/servc/get/by/contractId/and/ssuId')
    .data(params)
    .done(callback)
    .go();
};

//查询条款信息
exports.getContractTermList = function (params, callback) {// 获取条款信息列表
    api.post('/contract/term/list/get')
    .data(params)
    .done(callback)
    .go();
};

//结束合同阶段
exports.stepToNextContractTrackPhase = function (params, callback) {// 结束当前阶段，进入下一阶段
    api.post('/contract/track/phase/stepToNext/do')
    .data(params)
    .done(callback)
    .go();
};

//履约完成申请
exports.applyContractFulfillFinished = function (params, callback) {// 履约完成申请
    api.post('/contract/fulfill/finished/apply/do')
    .data(params)
    .done(callback)
    .go();
};

//申请验收完成
exports.applyContractCheckFinished = function (params, callback) {// 申请验收完成
    api.post('/contract/check/finished/apply/do')
    .data(params)
    .done(callback)
    .go();
};

//获取合同监控数据
exports.getContractMonitorDataList = function (params, callback) {// 获取合同监控数据列表
    api.post('/contract/monitor/data/list/get')
    .data(params)
    .done(callback)
    .go();
};

//带分页的合同操作记录列表
exports.getContractRecordList = function (data, callback) {// 获取合同操作记录分页列表
    api.post('/contract/record/list/get')
    .data(data)
    .done(callback)
    .go();
};

//申请审核合同信息
exports.applyContract = function (data, callback) {// 申请审核合同信息
    api.post('/contract/apply/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取合同日志
exports.getContractLog = function (params, callback) {
    api.get('/contract/log/get')
    .params(params)
    .done(callback)
    .go();
};

// 获取合同日志列表
exports.getContractLogListByContractNo = function (params, callback) {
    api.get('/contract/log/list/get/by/contractNo')
    .params(params)
    .done(callback)
    .go();
};

//合同发送站点信
exports.doContractSendMsg = function (data, callback) {
    api.post('/contract/send/msg/do')
    .data(data)
    .done(callback)
    .go();
};

//获取合同阶段列表
exports.getContractTrackPhaseListByContractId = function (data, callback) {
    api.post('/contract/track/phase/list/get/by/contractId')
    .data(data)
    .done(callback)
    .go();
};

// 老合同验证
exports.checkLegacyContract = function (callback) {
    api.post('/contract/legacy/contract/check')
    .done(callback)
    .go();
};

// 根据设备查找合同信息
exports.getContractByDeviceNo = function (data, callback) {
    api.post('/contract/get/by/devcSubNoId/and/servcType')
    .data(data)
    .done(callback)
    .go();
};

// ================ 区域价格 =================
// 根据合同商品id获取区域价格列表
exports.getContractGoodsAreaPriceListByContractGoodsItemId = function (params, callback) {
    api.get('/contract/goods/area/price/list/get/by/contractGoodsItemId')
    .params(params)
    .done(callback)
    .go();
};

// ================ 合同适用机构 =================
// 获取合同适用机构ids
exports.getContractAppliedShopIds = function (data, callback) {
    api.post('/contract/applied/shopIds/get')
    .data(data)
    .done(callback)
    .go();
};

// 查询合同服务特定价格预览
exports.getContractServcOrgPriceRecList = function (data, callback) {
    api.post('/contract/servc/org/price/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 查询合同服务2特定价格预览
exports.getContractServc2OrgPriceRecList = function (data, callback) {
    api.post('/contract/servc2/org/price/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/contract.js
// module id = 22
// module chunks = 1